<span class="middle-ellipsis">
    <span class="start" *ngIf="text.start" [title]="text.full">{{text.start}}</span>
    <span class="middle" *ngIf="text.middle" [title]="text.full">{{text.middle}}</span>
    <span class="end" *ngIf="text.end" [title]="text.full">{{text.end}}</span>
</span>